import type { Game } from '../hooks/useGames';
import type { GameLive } from '../hooks/useGamesLive';

export interface CategoryWithGamesLive {
  id: string;
  name: string;
  description?: string;
  type: string;
  order: number;
  games: Game[];
  gamesLive?: string[];
}

export interface MenuWithItems {
  id: string;
  name: string;
  style: string;
  order: number;
  items?: string[];
  games?: Game[];
}

export function convertLiveGameToGame(liveGame: GameLive): Game {
  return {
    id: liveGame.id,
    name: liveGame.tableConfig?.tableName || liveGame.id,
    gameCode: liveGame.id,
    launchCode: liveGame.id,
    type: 'casinolive',
    subtype: liveGame.tableConfig?.gameType || 'live',
    platform: liveGame.platform || {
      color: '#FF6B35',
      id: 999
    },
    provider: liveGame.provider || 'Live',
    external: true,
    order: 0,
    info: {
      rtp: undefined,
      branded: undefined,
      lines: undefined,
      volatility: undefined,
      reels: undefined,
      jackpot: undefined,
      jackpotValue: undefined,
      functionality: undefined,
      theme: undefined,
      exclusive: undefined
    },
    images: {
      thumbURL: liveGame.dealer?.dealerPictureUrl,
      landscapeImgURL: liveGame.tableConfig?.dynamicImageUrl,
      otherImgURL: liveGame.tableConfig?.asaAlternativeImage
    },
    partnerID: liveGame.partnerID || 'live',
    isNew: false,
    docID: liveGame.id
  };
}

export function convertLiveCategoriesToCategories(
  categories: CategoryWithGamesLive[],
  gamesLive: GameLive[]
): CategoryWithGamesLive[] {
  const findLiveGameById = (gameId: string) => gamesLive.find(game => game.id === gameId);

  return categories.map(category => {
    if (category.gamesLive && Array.isArray(category.gamesLive)) {
      const liveGameIds = category.gamesLive;
      const convertedGames = liveGameIds
        .map(gameId => findLiveGameById(gameId))
        .filter(liveGame => liveGame !== undefined)
        .map(liveGame => convertLiveGameToGame(liveGame!));
      
      return {
        ...category,
        games: convertedGames || []
      };
    }
    return {
      ...category,
      games: category.games || []
    };
  });
}

export function convertLiveMenuToMenu(
  selectedMenu: MenuWithItems,
  gamesLive: GameLive[]
): MenuWithItems {
  const findLiveGameById = (gameId: string) => gamesLive.find(game => game.id === gameId);

  if (selectedMenu.items && Array.isArray(selectedMenu.items)) {
    const liveGameIds = selectedMenu.items;
    const convertedGames = liveGameIds
      .map(gameId => findLiveGameById(gameId))
      .filter(liveGame => liveGame !== undefined)
      .map(liveGame => convertLiveGameToGame(liveGame!));
    
    return {
      ...selectedMenu,
      games: convertedGames
    };
  }
  return selectedMenu;
}